import { Tooltip } from 'react-tooltip'
import DynamicFaIcon from '../DynamicFaIcon/DynamicFaIcon'

interface RemarksIndicatorProps {
    remarks: string | undefined
    orderId?: string | number
}

export const RemarksIndicator: React.FunctionComponent<RemarksIndicatorProps> = (props: RemarksIndicatorProps) => {
    const { remarks, orderId } = props

    return (
        <>
            <div
                className='flex space-x-1.5 text-[--tb-text] font-semibold items-center justify-center cursor-pointer'
                id={`remarks-${orderId}`}
            >
                <DynamicFaIcon iconName='comment' />
                <DynamicFaIcon
                    iconName='circle'
                    style={{ fontSize: '0.45rem' }}
                    className='text-[--tb-primary] rounded-full bg-[--tb-primary] -mt-2 w-[7px] h-[7px]'
                />
            </div>
            <Tooltip
                anchorSelect={`#remarks-${orderId}`}
                variant='light'
                className='bg-white bg-opacity-100 p-0 m-0 rounded-lg shadow-lg z-50'
            >
                <div className='flex flex-col items-center gap-y-0.5 py-1 px-1'>
                    <span className='text-xs text-[--tb-textLight]'>{remarks}</span>
                </div>
            </Tooltip>
        </>
    )
}
